import React from 'react';
import { Flex, Input, Typography } from 'antd';
import { FormikProps } from 'formik';

import { IntegrationEmailProps } from '../service/integration-email.interface';

interface Props {
    formik: FormikProps<IntegrationEmailProps>;
}

export const IntegrationEmailForm = ({ formik }: Props) => {
    const handleChange = (type: string, value: string) => {
        const text = value.length > 1 ? value : value.trim();
        void formik.setFieldValue(type, text);
    };

    return (
        <Flex vertical gap={4}>
            <Typography.Text>Почта для получения заказов</Typography.Text>
            <Input
                placeholder={'qwe@qw.com'}
                value={formik?.values?.value}
                onChange={event => {
                    handleChange(`value`, event.target.value);
                }}
            />
        </Flex>
    );
};
